module.exports = __webpack_public_path__ + "img/alloys@2x.6b22a20.jpg";